module.exports = __webpack_public_path__ + "static/media/ios-finger-print.82accc8a.svg";